import { FieldValue, LookupValue } from '../../data-objects'
import { ModalSize } from '../enums'
import { FieldDefinition } from './field-definition'

export class LinkDefinition {
  public linkedEntity: string
  public linkedFields: string
  public include: string
  public viewName: string

  public get includedFields(): string[] {
    let res: string[] = []
    if (this.include) {
      res = this.include.split(',').map((f) => f.trim())
    }
    return res
  }

  constructor(link: LinkDefinition) {
    this.linkedEntity = link.linkedEntity
    this.linkedFields = link.linkedFields
    this.include = link.include
    this.viewName = link.viewName
  }
}

export enum LookupMode {
  Default,
  Dropdown,
}

export class LookupFieldDefinition extends FieldDefinition {
  public linkedEntity: string
  public linkedFields: string
  public viewName: string
  public viewFilterFields: string
  public inlineSearchView: string
  public inlineSearchFields: string
  public visualization: LookupMode
  public modalSize: ModalSize
  public modalSizeHorizontal: ModalSize
  public modalSizeVertical: ModalSize
  public links: LinkDefinition[]
  public include: string
  public optionClass: string
  public pageSize: number

  public get isMultiEntity(): boolean {
    return this.links.length > 1
  }

  public get includedFields(): string[] {
    let res: string[] = []
    if (this.include) {
      res = this.include.split(',').map((f) => f.trim())
    }
    return res
  }

  constructor(field: LookupFieldDefinition) {
    super(field)
    this.linkedEntity = field.linkedEntity
    this.linkedFields = field.linkedFields
    this.viewName = field.viewName
    this.viewFilterFields = field.viewFilterFields
    this.inlineSearchView = field.inlineSearchView
    this.inlineSearchFields = field.inlineSearchFields
    this.visualization = field.visualization
    this.modalSize = field.modalSize
    this.modalSizeHorizontal = field.modalSizeHorizontal
    this.modalSizeVertical = field.modalSizeVertical
    this.links = field.links.map((l) => new LinkDefinition(l))
    this.include = field.include
    this.optionClass = field.optionClass
    this.pageSize = field.pageSize
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getFieldValue(): FieldValue<any> {
    const toReturn = new LookupValue()
    return toReturn
  }
}
